import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/core/styles";
import AuthContext from "../contexts/AuthProvider";
import createCustomTheme from "./createCustomTheme";

const CustomThemeProvider = ({ children }) => {
  const { userDetails } = useContext(AuthContext);

  const theme = useMemo(() => {
    // A validacao/normalizacao do hex acontece em theme/tokens.js, entao
    // podemos repassar os valores crus da sessao diretamente.
    return createCustomTheme(
      userDetails?.implementation_color,
      userDetails?.implementation_text_color,
    );
  }, [
    userDetails?.implementation_color,
    userDetails?.implementation_text_color,
  ]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

CustomThemeProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default CustomThemeProvider;
